<div class="layout-ParentDiv innerDiv deleteuserPage">
    <div class="layout-dashboard" >
        <p-toast key="toastmsg"></p-toast>

            <!-- <p-toast key="toastmsg"></p-toast>Fmes -->

            <div class="mainDivHeader">
                <div class="leftdiv">
                    <h4>User Delete Request List <span class="badge">{{totalRecords }}</span></h4>
                </div>
                <div class="rightDiv">
                    <button class="exportBTn" (click)="exportExcel()"> <span><img
							src="../../../assets/images/backend-image/header/exportIcon.svg" alt=""></span>
					Export</button>
                </div>
            </div>

            <div class="mainDivBody">
                <div class="date-filterDiv">
                    <ul class="filtersList">
                        <li>
                            <p-dropdown inputId="searchfield" [options]="searchBy" [(ngModel)]="searchby"
                            optionLabel="label"></p-dropdown>
                        </li>
                        <li>
                        <p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050" [(ngModel)]="startDate"
                            class="p-calendar w-100" inputId="calendar" dateFormat="dd/mm/yy" [showIcon]="true" placeholder="FROM: dd / mm / yy"></p-calendar>
                        </li>
                        <li>
                        <p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050" [(ngModel)]="endDate"
                            class="p-calendar" inputId="calendar" dateFormat="dd/mm/yy" [showIcon]="true" placeholder="To: dd / mm / yy"></p-calendar>
                        </li>
                        <li>
                        <!-- <button pButton pRipple label="Search" class="p-button p-mr-1 p-mb-" (click)="loadWallet($event)"></button> -->
                        <button (click)="loaduserDeleteRequestlist($event)" class="searchFilterBtn">
                            <img src="../../../assets/images/backend-image/common-images/search.svg" alt="">
                        </button>
                        </li>
                        <li>
                            <!-- <button pButton label="Clear Filters" class="p-button-outlined p-mr-2 p-mb-2" icon="pi pi-filter-slash" (click)="clear()"></button> -->
                        <button (click)="clear()" class="clearFilterBtn">
                            <img src="../../../assets/images/backend-image/common-images/delete.svg" alt="">
                            <span>Clear All</span>
                        </button>
                        </li>
                    </ul>
                </div>

                <div class="maintableDiv">
                    <div class="tableParanet">
                        <p-table class=" expandable" #dt [value]="userDeletelist" [paginator]="true" [rows]="10" [lazy]="true"
                            [scrollable]="true" scrollHeight="auto" scrollDirection="both"
                            (onLazyLoad)="loaduserDeleteRequestlist($event)" [totalRecords]="totalRecords" [loading]="loading"
                            [rowsPerPageOptions]="paginationOption" autoLayout="true"
                            styleClass="p-datatable-gridlines p-datatable-striped">

                            <ng-template pTemplate="header" let-columns>
                                <tr>
                                    <th pfrozencolumn="" class="p-element col-td-main text-nowrap  userNameTD" pSortableColumn="amenities" alignfrozen="left">
                                        <div class="p-d-flex p-jc-between p-ai-center">
                                            Username                                
                                        </div>
                                    </th>
                                    <th pfrozencolumn="" class="p-element col-td-main text-nowrap  userEmailTD" pSortableColumn="email" alignfrozen="left">
                                        <div class="p-d-flex p-jc-between p-ai-center">
                                            Emailid
                                        </div>
                                    </th>
                                    <th pfrozencolumn="" class="p-element col-td-main text-nowrap  userMobileTD pSortableColumn="mobileNumber alignfrozen="left">
                                        <div class="p-d-flex p-jc-between p-ai-center">
                                            Mobile Number
                                        </div>
                                    </th>

                                    <th pfrozencolumn="" class="p-element col-td-main text-nowrap RequestedDateTD"
                                        style="left: 0px;" pSortableColumn="startDate">
                                        <div class="p-d-flex p-jc-between p-ai-center">
                                            Requested Date
                                        </div>
                                    </th>

                                    <th pfrozencolumn="" class="p-element col-td-main text-nowrap reasonTD"
                                        style="left: 0px;" pSortableColumn="startDate">
                                        <div class="p-d-flex p-jc-between p-ai-center">
                                            Reason
                                        </div>
                                    </th>

                                    <th pfrozencolumn="" class="p-element col-td-main text-nowrap MessageTD"
                                        style="left: 0px;" pSortableColumn="message">
                                        <div class="p-d-flex p-jc-between p-ai-center">
                                            Message                             
                                        </div>
                                    </th>


                                    <th pfrozencolumn="" class="p-element col-td-main text-nowrap actionTD  p-frozen-column" style="justify-content: center;">
                                        
                                            Action
                                        
                                    </th>
                                </tr>
                                <tr>
                                    <th [ngSwitch]="userName" pfrozencolumn=""
                                        class="p-element col-td-main text-nowrap  userNameTD" style="left: 0px;">
                                        <input pInputText type="text"
                                            (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'userName', 'contains')"
                                            [value]="dt.filters['userName'] ? dt.filters['userName'].value : ''" />
                                    </th>
                                    <th [ngSwitch]="email" pfrozencolumn=""
                                        class="p-element col-td-main text-nowrap  userEmailTD" style="left: 0px;">
                                        <input pInputText type="text"
                                            (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'email', 'contains')"
                                            [value]="dt.filters['email'] ? dt.filters['email'].value : ''" />
                                    </th>
                                    <th [ngSwitch]="mobileNumber" pfrozencolumn=""
                                        class="p-element col-td-main text-nowrap  userMobileTD" style="left: 0px;">
                                        <input pInputText type="text"
                                            (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'mobileNumber', 'contains')"
                                            [value]="dt.filters['mobileNumber'] ? dt.filters['mobileNumber'].value : ''" />
                                    </th>
                                    <th [ngSwitch]="date" class="col-td-main RequestedDateTD"> </th>

                                    <th [ngSwitch]="venue" pfrozencolumn=""
                                        class="p-element col-td-main text-nowrap reasonTD" style="left: 0px;">
                                        <p-dropdown #pDropDownId [style]="{ width: '100%' }" inputId="id" appendTo="body" [showClear]="true"
                                            [options]="reasonList" [filter]="true" placeholder="All" [(ngModel)]="searchbyreason"
                                            optionLabel="label" (onChange)="reasonSelect($event)"></p-dropdown>
                                    </th>

                                    <!-- <th [ngSwitch]="Time" class="col-td-main">
                                    </th> -->
                                    <th [ngSwitch]="Time" class="col-td-main MessageTD">
                                    </th>
                                    <th [ngSwitch]="Time" class="col-td-main actionTD  p-frozen-column" style=" border-bottom: none!important;   background: #fefef6 !important;">
                                    </th>
                                </tr>
                            </ng-template>

                            <ng-template pTemplate="body" let-user>
                                <!-- *ngIf="user.createduserdata[0].disable==false" -->
                                <tr class="p-selectable-row">
                                    <td pfrozencolumn="" class="col-td-main userNameTD" alignfrozen="left"
                                        style="width: 200px; left: 0px;">
                                        {{user.fullName}}
                                    </td>

                                    <td pfrozencolumn="" class="col-td-main userEmailTD" alignfrozen="left"
                                        style="width: 200px; left: 0px;">
                                        {{user.email}}
                                    </td>
                                    <td pfrozencolumn="" class="col-td-main userMobileTD" alignfrozen="left"
                                        style="width: 200px; left: 0px;">
                                        {{user.mobileNumber}}
                                    </td>
                                    <td pfrozencolumn="" class="col-td-main RequestedDateTD">
                                        {{user.created_at | date : 'dd-MM-yyyy'}}
                                        <!-- date -->
                                    </td>

                                    <td pfrozencolumn="" class="col-td-main reasonTD">
                                        {{user.reason}}
                                        <!-- time -->
                                    </td>
                                    <td pfrozencolumn="" class="col-td-main MessageTD">
                                        {{user.message}}
                                    </td>

                                    <td class="actionTD  p-frozen-column">
                                        <div class="status-buttons">
                                            <!-- <button class="btn btn-danger" (click)="deleteUser(user)"
                                                [ngClass]="{ 'disabled-button': user.diable}">
                                                <i class="pi pi-user-minus "></i> <span>Delete</span> </button> -->
                                                <ul class="actionList">
                                                    <li>
                                                        <button (click)="deleteUser(user)" class="deleteuserBtn"><img
                                                            src="../../../assets/images/backend-image/common-images/deleteBtn.svg"> Delete</button>
                                                    </li>
                                                </ul>
                                        </div>
                                    </td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="emptymessage">
                                <tr>
                                    <td colspan="9">
                                        No Register User Delete Request found.</td>
                                </tr>
                            </ng-template>
                            </p-table>
                            </div>
                </div>        
            </div>
        <p-confirmDialog [style]="{width: '400px'}" id="confirmDialog"></p-confirmDialog>

    </div>
</div>